import Cookies from "universal-cookie"
import axios from "axios";

const apiEndPoint = window.location.protocol+'//'+window.location.host;
const axiosInstance = axios.create({
    baseURL: apiEndPoint,
});
const cookies = new Cookies();

export const getLoginUser = () => {
    return {
        "login": cookies.get('OAMUserName'),
    }
}



export class AuthApiService {

    static async getData(url, headers, cancelToken, data) {
        const config = {
            headers: {
                ...(headers || {}),
                'Content-Type': 'application/json'
            },
        };
        if (data) {
            config.data = data;
        }
        if (cancelToken && cancelToken.token) {
            config.cancelToken = cancelToken.token;
        }
        const response = await axiosInstance.get(url, config).catch((err) => {
            data = {error: (err && err.response && err.response.data && err.response.data.message) || 'An error has occurred'};
        });
        return data || response.data;
    }

    static async deleteData(url, headers, cancelToken, data) {
        const config = {
            headers: {
                ...(headers || {}),
                'Content-Type': 'application/json'
            },
        };
        if (data) {
            config.data = data;
        }
        if (cancelToken && cancelToken.token) {
            config.cancelToken = cancelToken.token;
        }
        const response = await axiosInstance.delete(url, config).catch((err) => {
            data = {error: (err && err.response && err.response.data && err.response.data.message) || 'An error has occurred'};
        });
        return data || response.data;
       // return Object.assign({},data||response.data,{status:response.status});
    }

    static async postMethod(url, data, headers, cancelToken) {
        const config = {
            headers: {
                ...(headers || {})
            }
        };
        if (cancelToken && cancelToken.token) {
            config.cancelToken = cancelToken.token;
        }
        let resData = '';
        const response = await axiosInstance.post(url, data, config).catch(thrown => {
            resData = {error: 'An error has occurred.' , errorData: thrown};
        });
        return resData || response.data;
    }


    static async putMethod(url, data, headers, cancelToken) {
        const config = {
            headers: {
                ...(headers || {})
            }
        };
        if (cancelToken && cancelToken.token) {
            config.cancelToken = cancelToken.token;
        }
        let resData = '';
        const response = await axiosInstance.put(url, data, config).catch(thrown => {
            resData = {error: 'An error has occurred.' , errorData: thrown};
        });
        return resData || response.data;
    }

    static async patchMethod(url, data, headers, cancelToken) {
        const config = {
            headers: {
                ...(headers || {})
            }
        };
        if (cancelToken && cancelToken.token) {
            config.cancelToken = cancelToken.token;
        }
        let resData = '';
        const response = await axiosInstance.patch(url, data, config).catch(thrown => {
            resData = {error: 'An error has occurred.' , errorData: thrown};
        });
        return resData || response.data;
    }

    async getEnvironment() {
        // return { "environment": "dev" }
        // return await AuthApiService.getData(`environment.json`);
          return await AuthApiService.getData(`/accountmanagement/webapi/unauthapi/environments`);
    }

    /*  My Profile Page Services  */
    async getUserInformation(userLogin) {
        // return userInfo
        // return await AuthApiService.getData(`GetUserInfo.json`);
         return await AuthApiService.getData(`/accountmanagement/webapi/authapi/userInformation`);
    }

    /*  Security Question Page Services  */
    async getChallengeQuestions() {
        // return getChallengeQue
        // return await AuthApiService.getData(`GetAllChallengeQue.json`);
         return await AuthApiService.getData(`/accountmanagement/webapi/unauthapi/allChallengeQuestions`);
    }

    async updateQuestion(name, payload) {
        
        return await AuthApiService.putMethod(`/accountmanagement/webapi/authapi/users/challengeQuestions`, payload);
    }

    /*  Change Password Page Services  */
    async updatePassword(name, payload) {
        
        return await AuthApiService.putMethod(`/accountmanagement/webapi/authapi/users/password`, payload);
    }

    async getLoginUserName(loginUser) {
        // return {"result":'FERDOUS  AHMED'}
        return await AuthApiService.getData(`/accountmanagement/webapi/authapi/users/name`);
    }

    async getSessionId() {
        //return await AuthApiService.getData(`/accountmanagement/webapi/sessionid`);
    }

    async getIdcsSessionId() {
        
        //return await AuthApiService.getData(`/accountmanagement/webapi/idcssessionid`);
    }

    async getUserInfo(sessionId) {
        //return {"result":'FERDOUS  AHMED'}
       // return await AuthApiService.getData(`/accountmanagement/userapi/userDetails`);
       return await AuthApiService.getData(`/accountmanagement/webapi/getUserInfo`);
    }

    async getMeUserInfos() {
        //return {"result":'FERDOUS  AHMED'}
       return await AuthApiService.getData(`/accountmanagement/webapi/meuserinfo`);
   }

    async getLogout(sessionId) {
        // return {"result":'FERDOUS  AHMED'}
        //return await AuthApiService.getData(`/accountmanagement/oauth/logout?session-id=${sessionId}`);
        return await AuthApiService.getData(`/accountmanagement/webapi/logout`);
    }

       /*  Remove MFA SMS service   */
       async postRemoveMobile(payload) {
        return await AuthApiService.postMethod(`/accountmanagement/webapi/authapi/removeMobile`, payload);
    }

    /* SMS - Enrollment  */
    async postEnrollMobile(payload) {
        return await AuthApiService.postMethod(`/accountmanagement/webapi/authapi/enrollMobile`, payload);
    }

    /* SMS - Request Passcode  Mobile*/
    async postRequestPassMobile(payload) {
        return await AuthApiService.postMethod(`/accountmanagement/webapi/authapi/requestPassMobile`, payload);
        }

    /* SMS - Validate Passcode Mobile */
    async postValidatePassMobile(payload) {
        return await AuthApiService.postMethod(`/accountmanagement/webapi/authapi/validatePassMobile`, payload);
    }

    /* EMAIL - Remove Pending Email Verification Request */
    async removePendingEmailVerification(payload) {
        return await AuthApiService.postMethod(`/accountmanagement/webapi/authapi/removePendingEmailVerification`, payload);
    }


    /* EMAIL - Request email verification link again 
    https://tenant-base-url/admin/v1/MeEmailVerifier
    */
    async requestEmailVerifier(payload) {
        return await AuthApiService.putMethod(`/accountmanagement/webapi/authapi/requestEmailVerifier`, payload);
    }

    /* Email Update */
    async patchUpdateEmail(payload) {
        return await AuthApiService.patchMethod(`/accountmanagement/webapi/authapi/updateEmail`, payload);
    }

    /* my device info */
    async getMyDeviceInfo() {
    return await AuthApiService.getData(`/accountmanagement/webapi/mydeviceinfo`);
   }

       /* my device info by filter type */
       async getMyDeviceInfoByFilter(type) {
        return await AuthApiService.getData(`/accountmanagement/webapi/mydeviceinfobyfilter/` + type);
       }

   /* delete my device */
   async deleteMyDevice(deviceId) {
       console.log(deviceId);
    return await AuthApiService.deleteData(`/accountmanagement/webapi/deletemydevice/` + deviceId);
   }

    /* my google key */
    async getGoogleKey() {
        return await AuthApiService.getData(`/accountmanagement/webapi/getgooglekey`);
    }

    /* refresh access token*/
    async refreshAccessToken(sessionId) {
        //return await AuthApiService.getData(`/accountmanagement/oauth/refresh?session-id=${sessionId}`);
    }
    /*refresh IDCS admin acccess token*/
    async refreshIDCSAccessToken(idcsSessionId) {
        //return await AuthApiService.getData(`/accountmanagement/oauthadmin/refresh?session-id=${idcsSessionId}`);
    }

    async requestEnrollEmailOtp(userid) {
        const payload = {
            "method":"EMAIL",
            "skipFactorVerification":"true"
            }
        return await AuthApiService.postMethod(`/accountmanagement/webapi/authapi/enrolledEmail/${userid}`, payload);
    }

}
